import { ChangeEvent, useState } from "react";
import { Button, Input, FormFeedback } from "reactstrap";
import AppSpinner from "../../../../elements/AppSpinner";
import useSummarizeText from "../../../../api/api-hooks/brie/useSummarizeText";
import AppCopy from "../../../../components/AppComponents/AppCopy";

const Summarizer = () => {
  const [text, setText] = useState<string>("");
  const [wordCount, setWordCount] = useState<number | "">("");
  const [language, setLanguage] = useState("");
  const [validation, setValidation] = useState({
    wcValidation: false,
    txtValidation: false,
  });

  const {
    summarizeText,
    restart: restartSummary,
    summary,
    summarizeLoading,
  } = useSummarizeText();

  return (
    <>
      <div
        className="d-flex flex-column"
        style={{
          boxShadow: "0px 1px 8px 2px rgba(0, 0, 0, 0.15)",
          padding: "24px",
          borderRadius: "8px",
          width: "100%",
        }}
      >
        <div className="d-flex w-100 align-items-center mb-3">
          <i
            style={{ fontSize: "55px", color: "#424342" }}
            className="mdi mdi-file-document-check-outline"
          ></i>
          <h2 className="ml-4">Summarizer</h2>
        </div>

        <p
          className="m-0 mb-1"
          style={{
            fontSize: "13px",
            fontWeight: 400,
            letterSpacing: "0.0025em",
          }}
        >
          Enter the text you want to summarize:
        </p>
        <Input
          placeholder="Enter your text here"
          rows={10}
          type="textarea"
          className="form-control"
          maxLength={4096}
          disabled={summarizeLoading}
          invalid={validation.txtValidation}
          onChange={handleChange}
          value={text ?? undefined}
          onFocus={() =>
            setValidation((prev) => ({ ...prev, txtValidation: false }))
          }
        />
        <FormFeedback>You have to enter the text to summarize</FormFeedback>
        <div className="mt-2 d-flex justify-content-end text-sm text-medium">
          {text?.length ?? 0} / 4096
        </div>
        <div style={{ height: 100 }}>
          <p className="text-dark text-sm mb-2">Setup word count:</p>
          <Input
            type="number"
            invalid={validation.wcValidation}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setWordCount(parseInt(e.target.value))
            }
            disabled={summarizeLoading}
            className="form-control"
            onFocus={() =>
              setValidation((prev) => ({ ...prev, wcValidation: false }))
            }
            value={wordCount}
            placeholder="The number of words in your summary"
          />
          <FormFeedback hidden={!validation.wcValidation}>
            Word limit missing
          </FormFeedback>
        </div>
        <div style={{ height: 100 }}>
          <p className="text-dark text-sm mb-2">
            Response Language (optional):
          </p>
          <Input
            type="text"
            invalid={validation.wcValidation}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setLanguage(e.target.value)
            }
            disabled={summarizeLoading}
            className="form-control"
            value={language}
            placeholder="The language you'd like the response to be in"
          />
        </div>
        <div className="d-flex justify-content-end mt-3">
          {!summarizeLoading ? (
            <>
              {summary && (
                <Button onClick={restart} outline size="sm">
                  Restart
                </Button>
              )}
              <Button
                color="primary"
                onClick={handleSummarize}
                size="sm"
                disabled={!text}
              >
                Summarize
              </Button>
            </>
          ) : (
            <div className="d-flex align-items-center">
              <AppSpinner size="xl" />
            </div>
          )}
        </div>

        {summary && (
          <>
            <div className="d-flex justify-content-between mt-5">
              <h3 className="text-primary">Summary:</h3>
              <AppCopy text={summary?.summary} />
            </div>
            <textarea
              className="form-control"
              rows={5}
              value={summary.summary}
              onChange={() => {}}
            ></textarea>
          </>
        )}
      </div>
    </>
  );

  function handleSummarize() {
    if (validate()) {
      //@ts-ignore
      summarizeText({ text: text, wordCount: wordCount, language: language });
    }
  }

  function handleChange(e: any) {
    setText(e.target.value);
  }

  function validate() {
    let valid = true;
    if (!wordCount) {
      valid = false;
      setValidation((prev) => ({ ...prev, wcValidation: true }));
    }
    if (!text) {
      valid = false;
      setValidation((prev) => ({ ...prev, txtValidation: true }));
    }
    return valid;
  }

  function restart() {
    restartSummary();
    setText("");
    setWordCount("");
  }
};

export default Summarizer;
